var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHitbtc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04453 6.38895L7.86678 10.8417L4.45653e-07 11.8589L9.04453 6.38895Z",
    fill: "#757C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1778 24.3477L13.1396 16.261L10.5947 15.2175L11.1778 24.3477Z",
    fill: "#333642"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86678 10.8402L5.79608 15.0555L4.45654e-07 11.8574L7.86678 10.8402Z",
    fill: "#707690"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1781 24.3478L10.595 15.2175L5.7959 15.0565L11.1781 24.3478Z",
    fill: "#505669"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86659 10.8402L10.595 15.2165L5.7959 15.0555L7.86659 10.8402Z",
    fill: "#696F87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04494 6.38895L15.5756 7.20186L7.86719 10.8417L9.04494 6.38895Z",
    fill: "#7B829D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7219 4.36615L18.6113 9.1029L18.9 4.72067L22.7219 4.36615Z",
    fill: "#7B829D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 1.65225L22.7217 4.36552L24.4998 4.58064L25 1.65225Z",
    fill: "#7B829D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5068 6.82917L24.5006 4.58113L22.7225 4.36615L20.5068 6.82917Z",
    fill: "#6E758C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1396 16.2613L13.333 10.825L10.5947 15.2177L13.1396 16.2613Z",
    fill: "#505669"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3339 10.825L10.5956 15.2177L7.86719 10.8415L13.3339 10.825Z",
    fill: "#5F647B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5756 7.2018L13.3339 10.8253L7.86719 10.8417L15.5756 7.2018Z",
    fill: "#757C96"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3331 10.825L13.1396 16.2613L18.1516 21.3478L13.3331 10.825Z",
    fill: "#43495A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7724 18.5058L18.126 11.9872L18.1513 21.3472L20.7724 18.5058Z",
    fill: "#676E87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6109 9.1031L18.1261 11.9882L13.333 10.8254L18.6109 9.1031Z",
    fill: "#676E87"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0383 13.0218L18.126 11.9882L18.6108 9.1031L21.0383 13.0218Z",
    fill: "#7D859F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0815 18.3244L18.9043 13.2798H20.7187L22.0815 18.3244Z",
    fill: "#7B829D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1719 6.12919L18.6115 9.10228L18.9002 4.72004L16.1719 6.12919Z",
    fill: "#757C96"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1261 11.9878L13.333 10.825L18.1513 21.3478L18.1261 11.9878Z",
    fill: "#5F647B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7732 18.5065L21.8298 19.0918L18.165 21.3479L20.7732 18.5065Z",
    fill: "#505669"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0814 18.2674L18.126 11.9872L20.7724 18.5058L22.0814 18.2674Z",
    fill: "#757C96"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1713 6.12877L13.333 10.8242L18.6109 9.10185L16.1713 6.12877Z",
    fill: "#7B829D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitbtc);
export default __webpack_public_path__ + "static/media/hitbtc.537eca56.svg";
export { ForwardRef as ReactComponent };